var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox"},[_c('input',_vm._b({staticClass:"checkbox__input",attrs:{"type":"checkbox","name":_vm.name},on:{"change":_vm.handleChange}},'input',_vm.checked,false)),_c('i',{staticClass:"checkbox__icon"}),_c('div',{staticClass:"checkbox__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }